import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { extraErrorDataIntegration, reportingObserverIntegration } from '~@sentry/integrations'
import { init } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = []

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:"https:\u002F\u002F2aac0feac1d104473f8f9f98dae8fedf@sentry.orderchamp.dev\u002F3",
    environment:"production",
    ignoreErrors:["ResizeObserver loop limit exceeded","ResizeObserver loop completed with undelivered notifications","Network Error","NetworkError","Failed to fetch","Load failed","TypeError: cancelled","TypeError: annulé","TypeError: abgebrochen","AbortError","Request aborted","timeout of 0ms exceeded","Navigation cancelled","NavigationDuplicated","Avoided redundant navigation","ChunkLoadError","Loading chunk","Loading CSS chunk",new RegExp("^Non-Error promise rejection captured with value", ""),new RegExp("instantSearchSDKJSBridgeClearHighlight", ""),"fb_xd_fragment","__gCrWeb","ceCurrentVideo","jigsaw is not defined","Can't find variable: gtag","gtag is not defined","The operation is insecure",new RegExp("null is not an object \\(evaluating 'document\\.head", "")],
    denyUrls:[new RegExp("extensions\\\u002F", "i"),new RegExp("^chrome:\\\u002F\\\u002F", "i"),new RegExp("^chrome-extension:\\\u002F\\\u002F", "i"),new RegExp("^moz-extension:\\\u002F\\\u002F", "i"),new RegExp("^safari-extension:\\\u002F\\\u002F", "i"),new RegExp("^safari-web-extension:\\\u002F\\\u002F", "i"),new RegExp("googletagmanager\\.com", "i"),new RegExp("google-analytics\\.com", "i"),new RegExp("connect\\.facebook\\.net", "i"),new RegExp("cdn\\.segment\\.com", "i")],
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
    reportingObserverIntegration({ types:["crash"] }),
  ]

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
